import { useState } from 'react';

import {
  EventUpdateNotificationSettings,
  EventUpdateNotificationSettingsModalProps
} from './EventUpdateNotificationSettingsModal';

type EventUpdateNotificationsModalOptions = Partial<EventUpdateNotificationSettingsModalProps>;

interface UseEventUpdateNotificationsModalOptions {
  submitHandler: (values: EventUpdateNotificationSettings) => void | Promise<void>;
  cancelHandler?: () => void | Promise<void>;
}

interface UseEventUpdateNotificationsModalValue {
  modalProps: EventUpdateNotificationSettingsModalProps;
  open: (modalOptions: EventUpdateNotificationsModalOptions) => void;
  close: () => void;
}

const useEventUpdateNotificationsModal = (
  options: UseEventUpdateNotificationsModalOptions
): UseEventUpdateNotificationsModalValue => {
  const [modalProps, setModalProps] = useState<
    Omit<EventUpdateNotificationSettingsModalProps, 'onCancel'>
  >({
    open: false,
    canResetRsvps: false,
    onSubmit: options.submitHandler
  });

  const open = (modalOptions: EventUpdateNotificationsModalOptions): void => {
    setModalProps((prev) => ({ ...prev, ...modalOptions, open: true }));
  };

  const close = (): void => {
    setModalProps((prev) => ({ ...prev, open: false }));
  };

  return {
    open,
    close,
    modalProps: {
      ...modalProps,
      onOpenChange: (isOpen) => setModalProps((prev) => ({ ...prev, open: isOpen })),
      onCancel: options.cancelHandler ?? close
    }
  };
};

export { useEventUpdateNotificationsModal };
